import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';

const EditSupplierModal = ({ isOpen, onClose, supplier, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    contact_person: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    postal_code: '',
    country: 'France',
    website: '',
    notes: '',
    is_active: true
  });

  useEffect(() => {
    if (supplier) {
      setFormData({
        name: supplier?.name || '',
        contact_person: supplier?.contact_person || '',
        email: supplier?.email || '',
        phone: supplier?.phone || '',
        address: supplier?.address || '',
        city: supplier?.city || '',
        postal_code: supplier?.postal_code || '',
        country: supplier?.country || 'France',
        website: supplier?.website || '',
        notes: supplier?.notes || '',
        is_active: supplier?.is_active !== false
      });
    }
  }, [supplier]);

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSave(supplier?.id, formData);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[1020] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm animate-fade-in">
      <div className="bg-card rounded-lg shadow-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto animate-scale-in">
        <div className="p-6 border-b border-border sticky top-0 bg-card">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                <Icon name="Edit" size={24} className="text-primary" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-foreground">Modifier le fournisseur</h3>
                <p className="text-sm text-muted-foreground">{supplier?.name}</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-muted rounded-lg transition-colors"
            >
              <Icon name="X" size={20} />
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Nom du fournisseur"
              type="text"
              placeholder="Ex: PlombPro"
              value={formData?.name}
              onChange={(e) => setFormData({ ...formData, name: e?.target?.value })}
              required
            />

            <Input
              label="Personne de contact"
              type="text"
              placeholder="Ex: Jean Dupont"
              value={formData?.contact_person}
              onChange={(e) => setFormData({ ...formData, contact_person: e?.target?.value })}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Email"
              type="email"
              placeholder="contact@fournisseur.fr"
              value={formData?.email}
              onChange={(e) => setFormData({ ...formData, email: e?.target?.value })}
            />

            <Input
              label="Téléphone"
              type="tel"
              placeholder="01 23 45 67 89"
              value={formData?.phone}
              onChange={(e) => setFormData({ ...formData, phone: e?.target?.value })}
            />
          </div>

          <Input
            label="Adresse"
            type="text"
            placeholder="15 Rue de la Plomberie"
            value={formData?.address}
            onChange={(e) => setFormData({ ...formData, address: e?.target?.value })}
          />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Input
              label="Ville"
              type="text"
              placeholder="Paris"
              value={formData?.city}
              onChange={(e) => setFormData({ ...formData, city: e?.target?.value })}
            />

            <Input
              label="Code postal"
              type="text"
              placeholder="75001"
              value={formData?.postal_code}
              onChange={(e) => setFormData({ ...formData, postal_code: e?.target?.value })}
            />

            <Input
              label="Pays"
              type="text"
              placeholder="France"
              value={formData?.country}
              onChange={(e) => setFormData({ ...formData, country: e?.target?.value })}
            />
          </div>

          <Input
            label="Site web"
            type="url"
            placeholder="www.fournisseur.fr"
            value={formData?.website}
            onChange={(e) => setFormData({ ...formData, website: e?.target?.value })}
          />

          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground">
              Notes
            </label>
            <textarea
              placeholder="Informations supplémentaires..."
              value={formData?.notes}
              onChange={(e) => setFormData({ ...formData, notes: e?.target?.value })}
              rows={3}
              className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary resize-none"
            />
          </div>

          <div className="flex items-center gap-2">
            <Checkbox
              id="is_active"
              checked={formData?.is_active}
              onCheckedChange={(checked) => setFormData({ ...formData, is_active: checked })}
            />
            <label htmlFor="is_active" className="text-sm text-foreground cursor-pointer">
              Fournisseur actif
            </label>
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1"
            >
              Annuler
            </Button>
            <Button
              type="submit"
              variant="default"
              iconName="Save"
              className="flex-1"
            >
              Enregistrer
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditSupplierModal;